import React from "react";
import ReactMarkdown from "react-markdown";
import { Container } from "./styles";

interface Props {
  content: string;
}

const MessageRenderer: React.FC<Props> = ({ content }) => {
  const loomRegex =
    /https:\/\/www\.loom\.com\/(share|embed)\/[a-zA-Z0-9]+[a-zA-Z0-9?=&#_-]*/;

  const youtubeRegex =
    /https?:\/\/(www\.)?(youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]{11})/;

  const loomMatch = content.match(loomRegex);
  const youtubeMatch = content.match(youtubeRegex);

  let markdownWithoutLinks = content;

  const iframes: React.ReactNode[] = [];

  if (loomMatch) {
    const loomUrl = loomMatch[0];
    const embedUrl = loomUrl.includes("/share/")
      ? loomUrl.replace("/share/", "/embed/")
      : loomUrl;

    iframes.push(
      <iframe key="loom" src={embedUrl} allowFullScreen title="Loom Video" />
    );

    markdownWithoutLinks = markdownWithoutLinks.replace(loomUrl, "");
  }

  if (youtubeMatch) {
    const videoId = youtubeMatch[3];
    const embedUrl = `https://www.youtube.com/embed/${videoId}`;

    iframes.push(
      <iframe
        key="youtube"
        src={embedUrl}
        allowFullScreen
        title="YouTube Video"
      />
    );

    markdownWithoutLinks = markdownWithoutLinks.replace(youtubeMatch[0], "");
  }

  return (
    <Container>
      <ReactMarkdown>{markdownWithoutLinks}</ReactMarkdown>
      {iframes}
    </Container>
  );
};

export default MessageRenderer;
